export default {
  acting_director: 'В лице',
  acting_document: 'На основании',
  address: 'Адрес юридический',
  alias: 'Псевдоним',
  bank: 'Банк',
  bik: 'БИК',
  email: 'E-mail',
  kpp: 'КПП',
  logo_img_raw: 'Лого',
  customerName: 'Название компании',
  ogrn: 'ОГРН',
  okato: 'ОКАТО',
  okpo: 'ОКПО',
  paymentAccount: 'Расчетный счет',
  real_address: 'Адрес фактический',
  telephone: 'Телефон',
  UNP: 'УНП',
  name: 'Название компании',
  payment_account: 'IBAN счет'
}
